/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import icons from '../../constants/icons';
import {
  Avatar,
  Container,
  Img, Info,
} from './styles';

interface Props {
  check: boolean;
  name: string;
  photo?: string;
  isPhoto: boolean;
  onChange?: Function;
  id?: string;
}

const ListItemCommon:React.FC<Props> = ({
  check, name, photo, isPhoto, onChange, id,
}) => (
  <Container onClick={() => onChange && onChange(id)}>
    <Img height={16} width={16} src={check ? icons.checkIcon : icons.unCheckIcon} />
    {isPhoto && (
      <Avatar src={photo} />
    )}
    <Info>{name}</Info>
  </Container>
);
export default ListItemCommon;
